export const borderRadius = {
  md: 8,
};
